/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteMediaPartnerRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {DeleteMediaPartnerResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const deleteMediaPartner = (request: DeleteMediaPartnerRequest, options?: CashRequestOptions) => post<DeleteMediaPartnerRequest, DeleteMediaPartnerResponse>("/2.0/cash/delete-media-partner", request, {...options, rejectOnError: true })